import React from "react";
import { PropsWithChildren } from "react";

export type ChildDividerProps = PropsWithChildren<{
  Divider: () => React.ComponentElement<any, any>;
}>;

export const ChildDivider = ({ Divider, children }: ChildDividerProps) => {
  const childrenList = React.Children.toArray(children);

  return (
    <>
      {childrenList.map((child, index) => {
        if (child && React.isValidElement(child)) {
          return (
            <React.Fragment key={child.key || index}>
              {index > 0 && <Divider />}
              {child}
            </React.Fragment>
          );
        }

        return null;
      })}
    </>
  );
};
